import React, { useContext, useEffect, useState } from 'react';
import { Table, Segment, Message, Loader } from 'semantic-ui-react';
import { UserContext } from '../../app/layout/App';

const ContactListPage = () => {
  const { state } = useContext(UserContext);
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/contact', {
      headers: { Authorization: `Bearer ${state.token}` },
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Erru');
        return data;
      })
      .then((data) => {
        setContacts(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [state.token]);

  if (loading) return <Loader active content='Loading...' />;
  if (error) return <Message negative><p>{error}</p></Message>;

  return (
    <Segment>
      <h3>Contact list ({contacts.length})</h3>
      {contacts.length === 0 ? (
        <p>No contacts yet.</p>
      ) : (
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>Organization</Table.HeaderCell>
              <Table.HeaderCell>Message</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {contacts.map((c) => (
              <Table.Row key={c.id}>
                <Table.Cell>{new Date(c.created_at).toLocaleDateString('fr-FR')}</Table.Cell>
                <Table.Cell>{c.name}</Table.Cell>
                <Table.Cell><a href={`mailto:${c.email}`}>{c.email}</a></Table.Cell>
                <Table.Cell>{c.organization || '—'}</Table.Cell>
                <Table.Cell style={{ whiteSpace: 'pre-wrap', maxWidth: 400 }}>{c.message}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Segment>
  );
};

export default ContactListPage;
